import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import EventCard from "@/components/EventCard";
import { useLang } from "@/context/LanguageContext";
import { Music, Bell } from "lucide-react";

export default function Concerts() {
  const { t } = useLang();
  const { data: concerts = [], isLoading } = useQuery({
    queryKey: ["concertsPage"],
    queryFn: async () =>
      (await api.get("/events", { params: { nordic: true, date_from: new Date().toISOString(), limit: 100 } })).data,
  });

  return (
    <>
      <Seo title={t("concerts_title")} description={t("concerts_desc")} canonicalPath="/concerts" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12">
        <div className="flex items-center gap-3 mb-3">
          <Music className="w-7 h-7 text-indigo-300" />
          <h1 className="font-serif text-3xl sm:text-4xl uppercase tracking-tight text-indigo-100">{t("concerts_title")}</h1>
        </div>
        <p className="text-stone-400 mb-8 max-w-2xl">{t("concerts_desc")}</p>
        <Link
          to="/alerts"
          data-testid="concerts-alert-cta"
          className="inline-flex items-center gap-2 mb-12 text-sm font-semibold text-indigo-300 hover:text-indigo-200 border border-indigo-700/50 hover:bg-indigo-900/20 px-4 py-2 rounded-md transition-all"
        >
          <Bell className="w-4 h-4" /> {t("concerts_alert_cta")}
        </Link>

        {isLoading ? (
          <div className="py-24 text-center text-stone-400">{t("loading")}</div>
        ) : concerts.length === 0 ? (
          <div data-testid="concerts-empty" className="text-center py-20 text-stone-400 border border-dashed border-[#272A34] rounded-lg">
            {t("concerts_none")}
          </div>
        ) : (
          <div data-testid="concerts-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {concerts.map((e, i) => <EventCard key={e.slug} event={e} index={i} />)}
          </div>
        )}
      </div>
    </>
  );
}
